<template>
  <v-data-table
    :headers="headers"
    :items="incomes"
    :items-per-page-options="CONST.ROWS_PER_PAGE_ITEMS"
    :items-per-page-text="CONST.ROWS_PER_PAGE_TEXT">
    <template #[`item.downloadDate`]="{ item }">
      {{ formatLocalDate(getRawItem(item).downloadDate) }}
    </template>
    <template #[`item.origin.name`]="{ item }">
      {{ getRawItem(item).origin?.name || '' }}
    </template>
    <template #[`item.receiver.name`]="{ item }">
      {{ getRawItem(item).receiver?.name || '' }}
    </template>
    <template #[`item.commodity.bagQuantity`]="{ item }">
      {{ getRawItem(item).commodity?.bagQuantity || '' }}
    </template>
    <template #[`item.commodity.packagingType.packagingType`]="{ item }">
      {{ getRawItem(item).commodity?.packagingType?.packagingType || '' }}
    </template>
    <template #[`item.commodity.amount`]="{ item }">
      {{ getRawItem(item).commodity?.amount || '' }}
    </template>
    <template #[`item.commodity.locationInPlant`]="{ item }">
      {{ getRawItem(item).commodity?.locationInPlant || '' }}
    </template>
    <template #[`item.commodity.grainType.name`]="{ item }">
      {{ getGrainInfo(getRawItem(item).commodity?.grainType) }}
    </template>
    <template #[`item.analysis.gramaje`]="{ item }">
      {{ getGramaje(getRawItem(item).analysis) }}
    </template>
    <template #[`item.actions`]="{ item }">
      <div class="action-cell">
        <v-btn v-if="canReadAnalysis" icon size="small" variant="text" class="table-action-button" aria-label="Analisis" @click="displayAnalysis(getRawItem(item))">
          <v-icon>analytics</v-icon>
        </v-btn>
        <v-btn v-if="canUpdate" icon size="small" variant="text" class="table-action-button" aria-label="Editar" @click="editItem(getRawItem(item))">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn v-if="canDelete" icon size="small" variant="text" color="error" class="table-action-button" aria-label="Borrar entrada" @click="requestDelete(getRawItem(item))">
          <v-icon>delete</v-icon>
        </v-btn>
      </div>
    </template>
    <template v-slot:no-data>
      <span>{{ CONST.NO_RESULTS_CHECK_FILTERS }}</span>
      <v-btn color="primary" @click="initialize">{{ CONST.REFRESH }}</v-btn>
    </template>
  </v-data-table>
  <v-dialog :model-value="!!deleteTarget" max-width="480" :persistent="deleting" @update:model-value="!deleting && (deleteTarget = null)">
    <v-card title="Borrar entrada">
      <v-card-text>
        <p>¿Borrar la entrada {{ deleteTarget?.incomeNo }} y retirar su stock? Esta acción no se puede deshacer.</p>
        <p class="mt-3">Solo se permite si no tiene reservas, procesos ni salidas asociados.</p>
        <v-alert v-if="deleteError" type="error" variant="tonal" class="mt-3">{{ deleteError }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn min-height="48" :disabled="deleting" @click="deleteTarget = null">Cancelar</v-btn>
        <v-btn v-if="canDelete" color="error" min-height="48" :loading="deleting" @click="deleteItem">Borrar entrada</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import CONST from '../../services/common/Constants.js'
import { formatLocalDate as formatDate, toLocalDateInput } from '../../services/common/UtilsFunctions'
import { mapGetters } from 'vuex'
export default {
  name: 'IncomeTable',
  data: () => ({
    CONST: {},
    headers: [
      {title: 'Nro. Entrada', align: 'center', key: 'incomeNo'},
      {title: 'Fecha', align: 'center', key: 'downloadDate'},
      {title: 'Origen', align: 'center', key: 'origin.name', sortable: false},
      {title: 'Destinatario', align: 'center', key: 'receiver.name', sortable: false},
      {title: 'Bolsas', align: 'center', key: 'commodity.bagQuantity', sortable: false},
      {title: 'Empaque', align: 'center', key: 'commodity.packagingType.packagingType', sortable: false},
      {title: 'Peso neto', align: 'center', key: 'commodity.amount', sortable: false},
      {title: 'Ubicacion', align: 'center', key: 'commodity.locationInPlant', sortable: false},
      {title: 'Grano', align: 'center', key: 'commodity.grainType.name', sortable: false},
      {title: 'Gramaje', align: 'center', key: 'analysis.gramaje'},
      {title: 'Acciones', align: 'center', key: 'actions', sortable: false}
    ],
    incomes: [],
    deleteTarget: null,
    deleting: false,
    deleteError: ''
  }),

  computed: {
    ...mapGetters(['isRefreshTableRequired']),
    ...mapGetters('incomeModule', ['getFilteredIncomes']),
    ...mapGetters('authModule', ['hasPermission']),
    canReadAnalysis () { return this.hasPermission('plant.analyses.read') },
    canUpdate () { return this.hasPermission('plant.incomes.update') },
    canDelete () { return this.hasPermission('plant.incomes.delete') }
  },

  created () {
    this.CONST = CONST
    this.initialize()
  },

  watch: {
    'getFilteredIncomes': function () {
      this.incomes = this.$store.getters['incomeModule/getFilteredIncomes']
    },
    'isRefreshTableRequired': function (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.initialize()
      }
    }
  },

  methods: {
    requestDelete (item) {
      if (!this.canDelete) return
      this.deleteTarget = item
      this.deleteError = ''
    },
    async deleteItem () {
      if (!this.canDelete || this.deleting || !this.deleteTarget) return
      this.deleting = true
      try {
        await this.$store.dispatch('incomeModule/deleteIncome', this.deleteTarget.id)
        this.deleteTarget = null
        this.initialize()
      } catch (error) {
        this.deleteError = error.response?.data?.message || 'No se pudo borrar la entrada.'
      } finally {
        this.deleting = false
      }
    },
    initialize () {
      this.$store.dispatch('incomeModule/getIncomes').then(() => {
        this.incomes = this.$store.getters['incomeModule/getIncomes']
      })
    },

    formatLocalDate (value) {
      return formatDate(value)
    },

    displayAnalysis (item) {
      if (!this.canReadAnalysis) return
      this.$store.dispatch('incomeModule/setSelectedItem', item)
      this.$store.dispatch('analysisModule/setAnalysisData', item.analysis)
      this.$store.dispatch('analysisModule/setDialogActived', true)
    },

    getRawItem (item) {
      return item.raw || item
    },

    getGrainInfo (item) {
      if (!item) {
        return ''
      }
      let result = item.name
      if (item.variety) {
        result = result.concat(` ${item.variety}`)
      }
      return result
    },

    getGramaje (analysis) {
      let gramaje = 'Sin analisis'
      if (analysis && analysis.id > 0) {
        gramaje = analysis.gramaje == null ? 'No aplica' : analysis.gramaje
      }
      return gramaje
    },

    editItem (item) {
      if (!this.canUpdate) return
      const selected = Object.assign({}, item, { downloadDate: toLocalDateInput(item.downloadDate) })
      this.$store.dispatch('incomeModule/setSelectedItem', selected)
      this.$store.dispatch('incomeModule/setDialogActived', true)
    }
  }
}
</script>
